import { render } from "./App.vue?vue&type=template&id=5e1610b5"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5e1610b5&lang=css"

import exportComponent from "/var/www/html/book_thoughts/frontend_dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__